import moment from 'moment'

export default {

  // export function camel (str) {
  //   const camel = (str || '').replace(/-([^-])/g, g => g[1].toUpperCase());

  //   return capitalize(camel);
  // }

  // export function camelActual (str) {
  //   return (str || '').replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
  // }

  // export function kebab (str) {
  //   return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  // }

  // export function capitalize (str) {
  //   str = str || '';

  //   return `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`;
  // }

  // export function findProduct (store, id) {
  //   return store.state.store.products.find(p => p.id === id);
  // }

  // export function isOnSale (variants) {
  //   return variants.some(variant => {
  //     return parseFloat(variant.price) < parseFloat(variant.compareAtPrice);
  //   });
  // }

  // export function randomNumber (min, max) {
  //   return Math.floor(Math.random() * max) + min;
  // }

  // export function randomString (length = 5) {
  //   let text = '';
  //   const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  //   for (let i = 0; i < length; i++) {
  //     text += possible.charAt(Math.floor(Math.random() * possible.length));
  //   }

  //   return text;
  // }

  formatDate: date => {
    return date ? moment(date).format('DD-MM-YYYY') : ''
  },

  formatDateLong: date => {
    return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
  },

  formatDateLongES: date => {
    return date ? moment(date).format('DD-MM-YYYY HH:mm:ss') : ''
  },

  randomElement: (arr = []) => {
    return arr[Math.floor(Math.random() * arr.length)];
  },

  kebab: str => {
    return (str || "").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  },

  removeAccents: str => {
    return str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : ''
  },

  toggleFullScreen: () => {
    let doc = window.document;
    let docEl = doc.documentElement;

    let requestFullScreen =
      docEl.requestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen ||
      docEl.msRequestFullscreen;
    let cancelFullScreen =
      doc.exitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.webkitExitFullscreen ||
      doc.msExitFullscreen;

    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      requestFullScreen.call(docEl);
    } else {
      cancelFullScreen.call(doc);
    }
  },

  convertUserFromFrontModelToApiModel: userModel => {
    return {
      id: userModel.id,
      username: userModel.userName,
      password: userModel.password,
      email: userModel.email,
      first_name: userModel.firstName,
      last_name_1: userModel.lastName1,
      last_name_2: userModel.lastName2,
      id_document_number: userModel.documentId,
      is_active: userModel.isActive,
      needs_password_update: userModel.needsPasswordUpdate,
      roles: userModel.roles
    };
  },

  convertUserFromApiModelToFrontModel: apiModel => {
    return {
      id: apiModel.id,
      userName: apiModel.username,
      password: apiModel.password,
      email: apiModel.email,
      firstName: apiModel.first_name,
      lastName1: apiModel.last_name_1,
      lastName2: apiModel.last_name_2,
      fullName:
        apiModel.first_name +
        " " +
        apiModel.last_name_1 +
        " " +
        (apiModel.last_name_2 ? apiModel.last_name_2 : ""),
      documentId: apiModel.id_document_number,
      isActive: apiModel.is_active,
      needsPasswordUpdate: apiModel.needs_password_update,
      roles: apiModel.roles
    };
  },

  showErrorToast: (component, errorFromRequest, defaultMessage) => {
    let finalErrorMessage;
    let errorMessages = [];

    let errors = errorFromRequest.response && errorFromRequest.response.data.errors;
    if (errors) {
      if (typeof errors === "object") {
        Object.keys(errors).forEach(function(key) {
          errorMessages = errorMessages.concat(errors[key]);
        });
      }
      finalErrorMessage = errorMessages.join("<br/>");
    } else {
      finalErrorMessage = defaultMessage;
    }

    component.$toast("Error:<br/>" + finalErrorMessage, {
      color: "error",
      x: "center",
      y: "top",
      icon: "mdi-information",
      timeout: 0,
      showClose: true,
      closeText: "Cerrar"
    });
  },

};
